var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"title":_vm.$t('models_and_train_configs.confusion_matrix_title') + _vm.model.name,"loading":_vm.loading},on:{"close_modal":_vm.close_modal},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('confusion-matrix',{staticStyle:{"margin-top":"10px"},attrs:{"model_results":_vm.model_results}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }